export default __webpack_public_path__ + "static/logo.intercable-063a6ae101ec8e16115b2a3bae2f5e75.png";